import { Suspense, ElementType, ComponentProps } from 'react';

// project imports
import Loader from './Loader';

// ==============================|| LOADABLE - LAZY LOADING ||============================== //

function Loadable<T extends ElementType>(Component: T) {
    return function LoadableComponent(props: ComponentProps<T>) {
        return (
            <Suspense fallback={<Loader />}>
                <Component {...props} />
            </Suspense>
        );
    };
}

export default Loadable;
